var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c("el-col", { attrs: { sm: 24, lg: 18 } }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { sm: 24, lg: 6 } },
            [
              _c(
                "router-link",
                { attrs: { to: _vm.baseRoute.path } },
                [_c("el-button", [_vm._v("Submit project")])],
                1
              ),
              _vm._v(" "),
              _vm.isLogged
                ? _c("el-button", { on: { click: _vm.logout } }, [
                    _vm._v("Logout"),
                  ])
                : _c(
                    "router-link",
                    { attrs: { to: _vm.loginLink } },
                    [_c("el-button", [_vm._v("Login")])],
                    1
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "navbutton" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.drawer,
                      expression: "drawer",
                    },
                  ],
                  staticClass: "checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.drawer)
                      ? _vm._i(_vm.drawer, null) > -1
                      : _vm.drawer,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.drawer,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.drawer = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.drawer = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.drawer = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "hamburger-lines" }, [
                  _c("span", { staticClass: "line line1" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "line line2" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "line line3" }),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Menu",
            visible: _vm.drawer,
            direction: "rtl",
            "with-header": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drawermenu" }, [
            _c(
              "div",
              { staticClass: "drawersection" },
              [
                _vm.isLogged
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.logout.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Logout")]
                    )
                  : _c("router-link", { attrs: { to: _vm.loginLink } }, [
                      _vm._v("\n                    Login\n                "),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "drawersection" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://globaldesignnews.com/about/",
                    target: "_blank",
                  },
                },
                [_vm._v("About Global Design News")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://globaldesignnews.com/awards/prize-design-furniture-lighting/",
                    target: "_blank",
                  },
                },
                [_vm._v("About Prize Designs")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://globaldesignnews.com/awards/prize-design-furniture-lighting/",
                    target: "_blank",
                  },
                },
                [_vm._v("About Future House Awards")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://metropolitanartspress.com/shop/",
                    target: "_blank",
                  },
                },
                [_vm._v("Metropolitan Arts Press")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.chi-athenaeum.org/",
                    target: "_blank",
                  },
                },
                [_vm._v("The Chicago Athenaeum Museum")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "drawersection" }, [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(
                  "Instructions for Prize Designs for Modern Furniture and Lighting"
                ),
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: "#" } }, [
                _vm._v("Instructions for Future House Awards"),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/pdf/bank_transfer_general.pdf",
                    target: "_blank",
                  },
                },
                [_vm._v("Bank Transfer Details")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/pdf/postal_application_prize_designs.pdf",
                    target: "_blank",
                  },
                },
                [_vm._v("Postal Application for Prize Designs")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/pdf/postal_application_future_house.pdf",
                    target: "_blank",
                  },
                },
                [_vm._v("Postal Application for Future House Awards")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://metropolitanartspress.com/shop/architecture/New%20-Modern-%20Furniture-Lighting",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "Prize Designs  for Modern Furniture and Lighting Book Order"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://metropolitanartspress.com/shop/architecture/Future%20-House-%20The-%20New-%20Domestic-%20Landscape",
                    target: "_blank",
                  },
                },
                [_vm._v("Future House Awards Book Order")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://globaldesignnews.com/terms-and-conditions/",
                    target: "_blank",
                  },
                },
                [_vm._v("Terms & Conditions")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://metropolitanartspress.com/shop/terms",
                    target: "_blank",
                  },
                },
                [_vm._v("Refund Policy")]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }